import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import VideoCard from "../Atomics/VideoCard/VideoCard";
import Paginate from "../Atomics/Paginate/Paginate";
import { useState, useEffect } from "react";
import { campaignFetcher, channelFetcher } from "../../api/requests";
import { paginate } from "../../api/requests";
import { Spinner } from "react-bootstrap";

const ChannelVideos = ({ id, campaign = false, videoCount, searchText }) => {
  const [videos, setVideos] = useState();
  const [paginationInfo, setPaginationInfo] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const getVideos = async () => {
    setIsLoading(true);
    try {
      const res = campaign
        ? await campaignFetcher.getCampaignVideos({ campaignId: id })
        : await channelFetcher.getChannelsVideos({
            id: id,
            search: searchText,
          });

      setVideos(res);
      setPaginationInfo(res);
      setTotalCount(res.count);
    } catch (error) {
      console.error("Failed to fetch channel videos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = async (arg) => {
    setIsLoading(true);

    try {
      let res;

      if (typeof arg === "string") {
        const startIndex = arg.indexOf("api") + 3;
        res = await paginate.get(arg.slice(startIndex));
      } else if (typeof arg === "object" && arg.baseUrl && arg.page) {
        res = await paginate.getByNumber(arg.baseUrl, arg.page);
      } else {
        res = arg;
      }

      setVideos(res);
      setPaginationInfo(res);
      setTotalCount(res.count);
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getVideos();
  }, [id, searchText]);

  return (
    <>
      <div
        className="video-block section-padding"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
        }}
      >
        <Row>
          <Col md={12}>
            <SectionHeader
              heading={
                videos?.count ? `ویدئوها (${videos?.count} ویدئو)` : "ویدئوها"
              }
            />
          </Col>

          {isLoading ? (
            <div
              className="d-flex justify-content-center mb-5"
              style={{ width: "100%" }}
            >
              <Spinner animation="border" role="status"></Spinner>
            </div>
          ) : videos?.results?.length > 0 ? (
            videos?.results.map((item, index) => (
              <Col xl={2} sm={4} className="mb-3" key={index}>
                <VideoCard
                  imgSrc={item.cover ? item.cover : "/img/v4.png"}
                  time={item.duration}
                  videoTitle={item.title}
                  videoCategory={item.categorys?.name}
                  views={item.counted_views}
                  timeAgo={item.published_date}
                  channelName={item.channel?.name}
                  channelId={item.channel?.id}
                  verified
                  imgHref={
                    campaign
                      ? `/video-page/${item.id}/?campaign=${item.campaign.id}&category=${item.categorys.id}`
                      : `/video-page/${item.id}/`
                  }
                  iconHref={
                    campaign
                      ? `/video-page/${item.id}/?campaign=${item.campaign.id}&category=${item.categorys.id}`
                      : `/video-page/${item.id}/`
                  }
                  videoTitleHref={
                    campaign
                      ? `/video-page/${item.id}/?campaign=${item.campaign.id}&category=${item.categorys.id}`
                      : `/video-page/${item.id}/`
                  }
                  videoPublisher={
                    item?.publisher?.first_name +
                    " " +
                    item?.publisher?.last_name
                  }
                  campaign={campaign}
                />
              </Col>
            ))
          ) : (
            <div className="mr-3">ویدئو ای وجود ندارد.</div>
          )}
        </Row>
      </div>
      <Paginate
        count={totalCount}
        value={paginationInfo}
        onPageChange={handlePageChange}
        limit={12}
      />
    </>
  );
};

export default ChannelVideos;
